import { ACTION_GET_GCASH_ACCOUNT_LISTS , ACTION_GET_GCASH_ACCOUNT_LISTS_SUCCESS, ACTION_GET_GCASH_ACCOUNT_LISTS_ERROR} from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}


export const getGcashAccountListsReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_GET_GCASH_ACCOUNT_LISTS:
            return { ...state, isLoading: true, erro_msg: undefined }
        case ACTION_GET_GCASH_ACCOUNT_LISTS_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data }
        case ACTION_GET_GCASH_ACCOUNT_LISTS_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}